var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgToTheRight = function SvgToTheRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.613.21.094.083 4 4c.029.028.055.059.08.09l-.08-.09a1.008 1.008 0 0 1 .292.675L18 5v.033l-.004.052L18 5a1.008 1.008 0 0 1-.22.625l-.073.082-4 4a1 1 0 0 1-1.497-1.32l.083-.094L14.585 6H1a1 1 0 0 1-.117-1.993L1 4h13.585l-2.292-2.293a1 1 0 0 1-.083-1.32l.083-.094a1 1 0 0 1 1.32-.083Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};
export default SvgToTheRight;